import Vue from 'vue'

Vue.component('dnavigation', require('@/components/DNavigation.vue').default)
Vue.component('dteam', require('@/components/DTeam.vue').default)
Vue.component('dwebpimage', require('@/components/DWebpImage.vue').default)

// notification popup
Vue.component('dnotification', require('@/components/DNotification.vue').default)
